/** @module SiteAdmin/PDFFileRenderer */
define([
	"dojo/_base/declare",
	"csi",
    "csi/comm",
	"csi/heading/Url",
	"csi/locale",
	"csi/widget/MessageDialog"
], function(declare,csi,comm,Url,locale,MessageDialog) {

	return declare(Url, {
		idStatus: "PDF.Status",

		/**
		 * @override
		 * Report success or failure of PDFRequest if on DataPackage view (as opposed to table view)
		 */
		onMonitor: function(amc, newValue) {
			var ctx = amc.ctx;
			var view = ctx.view;
			var dp = ctx.getNode();

			// refresh row/view
			view.redrawNode(amc.refNode);

			// notify user if in DataPackage view
			if (view.getViewURL() == dp.$URL) {
				var req = ctx.cache.addNode(amc.params.urlRequest);

				if (!req || (req.Status == "Failed")) {
					// display error message
					new MessageDialog({
						buttons: [MessageDialog.BUTTON_OK],
						materialIcon: MessageDialog.ICON_ERROR,
						message: req ? req.StatusMessage : locale.resource("ErrorPdfRequestCancelled"),
						title: locale.resource("ERROR")
					}).show();
				} else if (req.Status == "Succeeded") {
					// open PDF file
					csi.browserWindow(comm.getFileHref(req.File, false, req.FileName));
				}

				view.postAction();
			}

			return true;
		},

		/**
		 * Track in-progress PDFRequest URL; it can be deleted while in progress, so cannot just get it in onMonitor 
		 */
		onMonitorStart: function(amc) {
			amc.params = {
				urlRequest: amc.ctx.getNode().PDFRequests.last()
			};
		}
	});
});